import scrollLock from 'scroll-lock';
import Slider from './Slider.js';
import Gallery from './GalleryGrid.js';
import { isMobile } from '../utils';

export default class Modal {

    constructor() {

		this.modal = document.querySelector('.modal-outer');

		if(!this.modal) {
			return;
		}

		// sliders
		const digitalsSlider = this.modal.querySelector('[data-digitals-slider]');

		this.portfolioSlider = document.querySelector('[data-portfolio-slider]');
		this.portfolioSliderIsMobile = document.querySelector('[data-portfolio-slider-sm]');

		this.slider = null;

		if(isMobile()) {
			this.slider = this.portfolioSliderIsMobile;
		} else {
			this.slider = this.portfolioSlider;
		}

		new Slider(this.slider);

		// gallery
		this.galleryView = this.modal.querySelector('[data-portfolio-gallery]');
		this.galleryViewToggle = this.modal.querySelector('[data-open-gallery]');
		this.galleryViewToggleClose = this.modal.querySelector('[data-close-gallery]');
		this.galleryViewItems = document.querySelectorAll('.c-gallery__item');

		// modal content grab the digitals or the portfolio items
		this.digitals = this.modal.querySelector('[data-digitals]');
		this.portfolio = this.modal.querySelector('[data-portfolio]');

        this.openDigitalsBtn = document.querySelector('[data-open-digitals]');
		this.openPortfolioBtn = document.querySelector('[data-open-portfolio-mobile]');

		this.closeBtn = this.modal.querySelector('[data-close-modal]');

		// open modal and initialize digitals slider
		if (digitalsSlider) {
			this.openDigitalsBtn.addEventListener('click', e => {
				this.openModal();
				this.digitals.classList.add('show-content');
				this.digitalsSlider = new Slider(digitalsSlider);
			});
		}

		// open modal and initialize portfolio slider
		if(!isMobile()) {
			this.galleryViewItems.forEach(image => {
				image.addEventListener('click', e => {
					this.openModal();
					this.portfolio.classList.add('show-content');

					const attr = image.getAttribute('data-gallery-item');
					const slide = this.slider.querySelector(`[data-contains-image-${attr}]`);
					const parent = slide.parentNode;
					const index = Array.prototype.indexOf.call(parent.children, slide);

					this.slider.swiper.slideTo(index, 0);
				});
			});
		}

		if(isMobile()) {
		// extra button only shown on mobile devices
			this.openPortfolioBtn.addEventListener('click', e => {
				this.openModal();
				this.portfolio.classList.add('show-content');
			});
		}

		// initialize gallery view
		if (this.galleryViewToggle) {
			this.galleryViewToggle.addEventListener('click', e => {
				this.openGallery();
			});
		}
		if (this.galleryViewToggleClose) {
			this.galleryViewToggleClose.addEventListener('click', e => {
				this.closeGallery();
			});
		}

        this.closeBtn.addEventListener('click', e => {
			this.closeModal();
		});

        let FocusableElements = this.modal.querySelectorAll('a, button');

		const firstFocusableEl = FocusableElements[0];
		const lastFocusableEl = FocusableElements[FocusableElements.length - 1];

		window.addEventListener('keydown', e => {
			if (e.key === 'Escape') {
				this.closeModal();
			}

			if (e.key === 'Tab' || e.key === 9) {
				if ( e.shiftKey ) /* shift + tab */ {
					if (document.activeElement === firstFocusableEl) {
						lastFocusableEl.focus();
						e.preventDefault();
					}
				} else /* tab */ {
					if (document.activeElement === lastFocusableEl) {
						firstFocusableEl.focus();
						e.preventDefault();
					}
				}
			}
		});
	}

	openGallery() {
		this.galleryViewToggle.classList.remove('is-active');
		new Gallery(this.galleryView);
		this.slider.classList.add('is-hidden');
	}

	closeGallery() {
		this.galleryViewToggle.classList.remove('is-active');
		this.galleryViewToggleClose.classList.add('is-active');
		this.slider.classList.remove('is-hidden');
	}

    openModal() {
		scrollLock.disablePageScroll(this.modal);
		document.body.classList.add('has-modal-open');
		this.modal.classList.add('is-active');
	}

	closeModal() {
		scrollLock.enablePageScroll();
		document.body.classList.remove('has-modal-open');
		this.modal.classList.remove('is-active');

		if(this.digitals) {
			this.digitals.classList.remove('show-content');
		}

		if(this.portfolio) {
			this.portfolio.classList.remove('show-content');
		}
	}
}